// Bump CURRENT_TERMS_VERSION for any material change to the Terms or the
// Privacy Policy: every non-admin user is asked to accept again on next login.
export const CURRENT_TERMS_VERSION = "1.1";

// Day version 1.1 went live
export const LEGAL_EFFECTIVE_DATE = "14 October 2026";

export const CONTACT_EMAIL = "ciaofridays@gmail.com";
